<template>
  <BasicSkeletor>
    <template #content>
      <div
        class="fixed top-0 right-0 bottom-0 z-[100] bg-white shadow-lg w-[40px] lg:w-[50px] h-screen flex flex-col items-center justify-between py-8 px-2"
      >
        <div class="h-[50px] w-full flex items-center justify-center">
          <PopupMenu @onClickLink="setActivePage" />
        </div>
        <NavigationDots :isMultimedia="multimediaItems.length > 0" />
        <div class="h-[50px] w-full flex items-center justify-center"></div>
      </div>

      <HMTTopSection data-scroll-name="top-section">
        <TopContent />
      </HMTTopSection>

      <TopDetails />

      <component v-if="detailsPage.visible" :is="detailsPage.component" />
      <OpenHouse />
      <component v-if="galleryPage.visible" :is="galleryPage.component" />

      <MultimediaSection
        v-if="multimediaItems.length > 0"
        :items="multimediaItems"
        :itemValue="activePage"
        data-scroll-name="multimedia"
      />

      <div v-for="page in pages" :key="page.name" :data-scroll-name="page.name">
        <component :is="page.component" />
      </div>

    </template>
    <template #footer>
      <Footer />
    </template>
  </BasicSkeletor>
</template>

<script>
  import { mapGetters } from 'vuex';

import BasicSkeletor from "@/shared/components/Skeletor/BasicSkeletor";
import HMTTopSection from "@/shared/components/TopSection";
import Footer from "./components/Footer";
import TopContent from "./components/TopContent";
import OpenHouse from "./components/OpenHouse";
import MultimediaSection from "./components/MultimediaSection";
import TopDetails from "./components/TopDetails";
import PopupMenu from "./components/PopupMenu";
import NavigationDots from "./components/NavigationDots";

  const MULTIMEDIA_PAGES = ['slideshow', 'video', 'video-slideshow', '360-tour'];

  export default {
    name: 'Rabbit',
    components: {
      BasicSkeletor,
      Footer,
      TopContent,
      HMTTopSection,
      OpenHouse,
      MultimediaSection,
      TopDetails,
      PopupMenu,
      NavigationDots
    },
    data () {
      return {
        activePage: null
      }
    },
    computed: {
      ...mapGetters('tour', ['getPages', 'getTopSection', 'getSettings']),
      detailsPage () {
        return {
          name: 'details',
          visible: !!this.getSettings.details,
          component: () => import('./pages/Details')
        }
      },
      galleryPage () {
        return {
          name: 'gallery',
          visible: !!this.getSettings.gallery,
          component: () => import('./pages/Gallery')
        }
      },
      multimediaItems () {
        return this.getPages
          .filter(page => MULTIMEDIA_PAGES.includes(page.value))
          .filter(page => page.value !== this.getTopSection)
          .map(({ value, label, componentName }) => ({
            value,
            label,
            component: () => import(`./pages/${componentName}`)
          }));
      },
      pages () {
        return this.getPages
          .filter(page => !MULTIMEDIA_PAGES.includes(page.value) && page.value !== 'details' && page.value !== 'gallery' && page.value !== this.getTopSection)
          .map(item => ({
            name: item.value,
            component: () => import(`./pages/${item.componentName}`)
          }));
      }
    },
    methods: {
      setActivePage (name) {
        this.activePage = name;
      }
    },
    created () {
      const script = document.createElement('script');
      script.src = '/tailwindcss4.js'
      document.head.appendChild(script);

      document.body.classList.add('rabbit-main-wrapper');
    }
  };
</script>

<style src="./styles/main.scss" lang="scss"></style>

<style lang="scss" scoped>
  :global(.rabbit-main-wrapper .main-wrapper) {
    padding-right: 50px;
    transition: padding-right 0.3s ease;
  }

  @media (max-width: 1024px) {
    .fixed.top-0.right-0.bottom-0 {
      /* Keep the panel visible but adjust its size */
      height: 100vh;
      width: 40px;
      padding: 15px 5px;
    }
    
    /* Still hide the bottom spacer on mobile */
    .h-\[50px\].w-full.flex.items-center.justify-center:last-child {
      display: none;
    }
    
    /* Adjust padding for the main content on mobile */
    :global(.rabbit-main-wrapper .main-wrapper) {
      padding-right: 40px;
    }
  }
</style>
